import { render, staticRenderFns } from "./publications.vue?vue&type=template&id=59d68e25&"
import script from "./publications.vue?vue&type=script&lang=js&"
export * from "./publications.vue?vue&type=script&lang=js&"
import style0 from "./publications.vue?vue&type=style&index=0&id=59d68e25&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports